import { Alert, Flex, Heading, View } from "@instructure/ui";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { SubjectService } from "../../services/SubjectService";
import { DashboardFilters, UserDetailContext } from "../../utils/Context";
import ACPC from "./ACPC";
import FacultyDashboard from "./Faculty/FacultyDashboard";

const Dashboard = () => {
  const { t } = useTranslation();
  const userDetails = useContext(UserDetailContext);
  const location = useLocation();
  const linkDetails = location.state;

  const [dashboardFilters, setDashboardFilters] = useState({
    subject: "",
    LOType: "",
    programs: [],
    categories: [],
    terms: [],
    masteryResults: "true",
    cycle: {},
    courseLevels: [],
    variety: ["outcome", "standard"],
  });

  const [trigger, setTrigger] = useState(false);
  // This is here to get the id of a subject, instead of the name when fetching programs by ac sub
  const [subjects, setSubjects] = useState(null);

  useEffect(() => {
    if (trigger) {
      setTrigger(false);
    }
  }, [trigger]);

  useEffect(() => {
    if (userDetails.role) {
      SubjectService.getSubjects().then((academicSubjects) => {
        if (academicSubjects.length) {
          setSubjects(academicSubjects);
          if (userDetails.isAC()) {
            setDashboardFilters((prevFilters) => ({
              ...prevFilters,
              LOType: "ISLO",
            }));
            setTrigger(true);
          } else {
            setDashboardFilters((prevFilters) => ({
              ...prevFilters,
              LOType: "PSLO",
            }));
            setTrigger(true);
          }
        }
      });
    }
  }, [userDetails]);

  return (
    <DashboardFilters.Provider value={dashboardFilters}>
      <View as="div">
        {location.pathname === "/" && (
          <div
            style={{
              borderBottom: "0.0625rem solid #C7CDD1",
              margin: "0 0 0.75rem 0",
            }}
          >
            <Flex justifyItems="space-between">
              <Flex.Item>
                <Heading as="h1" level="h2">
                  {t("navigation.dashboard")}
                </Heading>
              </Flex.Item>
              {userDetails.name && (
                <Flex.Item>
                  <span style={{ marginLeft: 15, fontSize: "1rem" }}>
                    {t("dashboard.welcomeText")}, {userDetails.name}
                  </span>
                </Flex.Item>
              )}
            </Flex>
          </div>
        )}
        {subjects?.length > 0 ? (
          <>
            {location.pathname === "/" &&
              (userDetails.isAC() ||
                (userDetails.isPC() && userDetails.ac_subjects.length > 0)) && (
                <ACPC
                  dashboardFilters={dashboardFilters}
                  setDashboardFilters={setDashboardFilters}
                  trigger={trigger}
                  setTrigger={setTrigger}
                  linkDetails={linkDetails}
                  subjects={subjects}
                />
              )}
            {(location.pathname === "/" || location.pathname === "/courses") &&
              (userDetails.isFaculty() || userDetails.isCC()) &&
              userDetails.ac_subjects.length > 0 && (
                <FacultyDashboard
                  trigger={trigger}
                  setTrigger={setTrigger}
                  subjects={subjects}
                />
              )}
            {location.pathname === "/courses" &&
              (userDetails.isAC() ||
                (userDetails.isPC() && userDetails.ac_subjects.length > 0)) && (
                <FacultyDashboard
                  trigger={trigger}
                  setTrigger={setTrigger}
                  subjects={subjects}
                />
              )}
            {!userDetails.isAC() && userDetails.ac_subjects.length === 0 && (
              <Alert variant="info">
                {t("dashboard.noAssociatedSubjects")}
              </Alert>
            )}
          </>
        ) : (
          subjects?.length === 0 && (
            <Alert variant="info">{t("dashboard.nothingFound")}</Alert>
          )
        )}
      </View>
    </DashboardFilters.Provider>
  );
};

export default Dashboard;
